import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { DocumentoEntrada } from '../../model/documento-entrada';
 

@Component({
  selector: 'app-testing',
  templateUrl: './testing.component.html',
  styleUrls: ['./testing.component.css']
})
export class TestingComponent implements OnInit {

     public documento: DocumentoEntrada = new DocumentoEntrada();

  constructor() { }

  ngOnInit() {    
  }
  
}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/services/testing/testing.component.ts